import Svg from 'components/utilities/svg'

const AngleIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Angle Icon</title>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M11.4913342,3 L7.98370015,11.7369596 C8.84077012,12.3138258 9.6352188,12.9681726 10.3670462,13.7 C11.8170462,15.15 12.9628795,16.8458333 13.8045462,18.7875 L13.893,19 L21.0670462,19 L21.0670462,21 L5.06704618,21 C4.51704618,21 3.9299921,20.9597668 3.53832543,20.5681002 C3.14665877,20.1764335 2.85165266,19.6635199 3.07972098,19 L9.49133418,3 L11.4913342,3 Z M7.22677107,13.6238635 L5.06704618,19 L11.71658,18.9993979 C11.011538,17.5277798 10.0950267,16.2279805 8.96704618,15.1 C8.42642347,14.5593773 7.84633176,14.0673318 7.22677107,13.6238635 Z" />
  </Svg>
)

AngleIcon.displayName = 'Angle'

export default AngleIcon
